import {Injectable} from '@angular/core';
import {fromEvent, Subject} from "rxjs";
import {CommonService} from "./common.service";

@Injectable({
  providedIn: 'root'
})
export class UserIdleService {

  public idle: Subject<boolean> = new Subject();
  public wake: Subject<boolean> = new Subject();

  isIdle = false;
  private idleAfterSeconds = 5400;
  private countDown;

  constructor(
    private commonService: CommonService,
  ) {
    // Setup events
    fromEvent(document, 'mousemove').subscribe(() => this.onInteraction());
    fromEvent(document, 'touchstart').subscribe(() => this.onInteraction());
    fromEvent(document, 'keydown').subscribe(() => this.onInteraction());
  }

  onInteraction() {
    // check user is logged in
    if (!this.commonService.getAuthenticationToken()) {
      return;
    }

    // Is idle and interacting, emit Wake
    if (this.isIdle) {
      this.isIdle = false;
    }

    // User interaction, reset start-idle-timer
    clearTimeout(this.countDown);
    this.countDown = setTimeout(() => {
      // check user is logged in
      if (!this.commonService.getAuthenticationToken()) {
        return;
      }

      // Countdown done without interaction - emit Idle
      this.isIdle = true;
      this.idle.next(true);
      this.commonService.removeAuthenticationToken();
    }, this.idleAfterSeconds * 1000)
  }
}
